<ng-container *ngIf="visible">
    <mat-progress-bar color="primary" class="z-[99] !fixed top-0 w-full" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>
</ng-container>